import React, { useCallback } from "react";
import { mdiClose, mdiMagnify } from "@mdi/js";
import Icon from "@mdi/react";

import Input from "components/Input";
import { useDebounceCallback } from "usehooks-ts";
import styles from "../style.module.scss";
import Button from "components/Button";

interface SearchInputProps {
  initialValue: string;
  onSearch: (value: string | null | undefined) => void;
  isMobile?: boolean;
  iconClassName?: string;
  resetSearch?: VoidFunction;
}

const SearchInput: React.FC<SearchInputProps> = ({
  initialValue,
  onSearch,
  iconClassName,
  isMobile,
  resetSearch
}) => {
  const debouncedSearch = useDebounceCallback((value: string | null) => {
    setIsSearching(true);
    onSearch((value && value.trim()) || null);
  }, 300);

  const [value, setValue] = React.useState<string>(initialValue);
  const [isSearching, setIsSearching] = React.useState<boolean>(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  };

  const handleSearch = useCallback(
    (searchValue: string) => debouncedSearch(searchValue),
    [debouncedSearch, value]
  );

  const handleResetSearch = () => {
    resetSearch && resetSearch();
    setIsSearching(false);
    setValue("");
  };

  return (
    <div className={isMobile ? "flex flex-col gap-3" : "flex flex-auto flex-row gap-3"}>
      <Input
        type="text"
        value={value}
        onChange={handleChange}
        placeholder="Search by load number, invoice number, or PO number"
        prefixNode={<Icon path={mdiMagnify} className={iconClassName ?? styles.searchIcon} />}
        inputClass="text-sm desktop:bg-background"
        className={!isMobile ? "flex-1" : undefined}
      />
      <Button variant="contained" onClick={() => handleSearch(value)}>
        Search
      </Button>
      {isSearching && !isMobile && (
        <Button variant="outline" iconButton onClick={handleResetSearch}>
          <Icon path={mdiClose} className="m-auto size-5" />
        </Button>
      )}
    </div>
  );
};

export default SearchInput;
